import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import compose from 'lodash.flowright';
import { mapProps } from 'recompose';

import { createLoadMoreMethod } from '../../../../util/apollo';
import FullScreenLoader from '../../../../components/global/FullScreenLoader';
import NotFound from '../../../pro/views/NotFound';
import ProUserPage from './components/ProUserPage';
import ShutterbugUserPage from './components/ShutterbugUserPage';
import { accountProfile as accountProfileQuery } from './graphql';
import { isProAccount } from '../../../../util/account';
import LogoPoweredBy from '../../../../components/global/LogoPoweredBy';
import Button from '../../../../components/global/Button';
import useOpenModal from '../../../../hooks/useOpenModal';
import { PHONE_AUTH_MODAL } from '../../../../constants/modals';

const propTypes = {
  accountProfile: PropTypes.shape({
    id: PropTypes.string,
    username: PropTypes.string,
    roles: PropTypes.arrayOf(PropTypes.string),
  }),
  loading: PropTypes.bool,
  onGoBack: PropTypes.func,
  isPMView: PropTypes.bool,
};

const UserPage = ({ accountProfile, loading, onGoBack, isPMView }) => {
  const openModal = useOpenModal();

  if (loading && !accountProfile) {
    return <FullScreenLoader />;
  }

  // Or 404 if no user.
  if (!accountProfile) {
    return <NotFound />;
  }

  const isPro = isProAccount(accountProfile);

  const IUserPage = isPro ? ProUserPage : ShutterbugUserPage;

  return (
    <Fragment>
      {!isPro && !isPMView && (
        <div className="profile-page-hero-header">
          <LogoPoweredBy className="mr-auto" />

          <Button
            btnOutline
            btnStyle="primary"
            btnSize="sm"
            onClick={() => {
              openModal(PHONE_AUTH_MODAL);
            }}
          >
            Login
          </Button>
          <Button
            btnStyle="primary"
            className="ml-1"
            btnSize="sm"
            to="/shutterbug/register"
          >
            Sign up
          </Button>
        </div>
      )}
      <IUserPage
        accountProfile={accountProfile}
        loading={loading}
        onGoBack={onGoBack}
        isPMView={isPMView}
      />
    </Fragment>
  );
};

const withAccountProfile = graphql(accountProfileQuery, {
  options: ({ match }) => ({
    notifyOnNetworkStatusChange: true,
    variables: {
      username: match.params.username,
    },
  }),
  skip: ({ match }) => !match.params.username,
});

UserPage.propTypes = propTypes;

export { UserPage as UserPageComponent };

export default compose(
  withRouter,
  withAccountProfile,
  mapProps(({ data, ...props }) => ({
    ...props,
    accountProfile: data?.accountProfile,
    loading: data?.loading,
    loadMore: createLoadMoreMethod({
      source: data?.accountProfile,
      recordsPath: 'hierarchy_items',
      fetchMore: data?.fetchMore,
    }),
  })),
)(UserPage);
